import { render, staticRenderFns } from "./PageDashboard.vue?vue&type=template&id=721b35c3&scoped=true&"
import script from "./PageDashboard.vue?vue&type=script&lang=js&"
export * from "./PageDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721b35c3",
  null
  
)

export default component.exports